import layout from '@/views/common/layout'
const goodsRouter = [
    {
        path: '/goods',
        component: layout,
        children: [
            {
                path: 'goodsList',
                component: () => import('@/views/goods/goodsList'),
                name: 'goodsList',
                meta: { title: '商品管理', icon: '', affix: true }
            },
            {
                path: '/addGoods',
                component: () => import('@/views/goods/editGoods'),
                name: 'editGoodsDetail',
                meta: { title: '编辑商品详情', icon: '', affix: true }
            },
            {
                path: 'editGoodsPicture',
                component: () => import('@/views/goods/editGoodsPicture'),
                name: 'editGoodsPicture',
                meta: { title: '图片管理', icon: '', affix: true }
            },
            {
                path: 'editGoodsDetail',
                component: () => import('@/views/goods/editGoodsDetail'),
                name: 'editGoodsDetail',
                meta: { title: '图片详情', icon: '', affix: true }
            },
        ]
    }
]

export default goodsRouter


// WEBPACK FOOTER //
// ./src/router/modules/goodsRouter.js